// extracted by mini-css-extract-plugin
export var chip = "_c6-0";
export var filterDropdown = "_c6-5";
export var filterItem = "_c6-6";
export var icon = "_c6-1";
export var removeButton = "_c6-3";
export var removeIcon = "_c6-4";
export var separator = "_c6-2";